import { render, staticRenderFns } from "./App.component.pug?vue&type=template&id=733f60ef&scoped=true&lang=pug&"
import script from "./App.component.ts?vue&type=script&lang=ts&"
export * from "./App.component.ts?vue&type=script&lang=ts&"
import style0 from "./App.component.scss?vue&type=style&index=0&id=733f60ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f60ef",
  null
  
)

export default component.exports